// Shared alerts module — imported by webpack at build time via @xolo/common/alerts.
//
// Usage:
//   import { createAlerts } from '@xolo/common/alerts';
//   const Alert = createAlerts({
//       removeButton: '<i class="icon-close remove-alert"></i>',
//       appendTo: ($alert) => $alert
//   });

export function createAlerts({ removeButton, appendTo }) {

    let Alert = {
        init: () => {
            if ($('.system-alert').length) Alert.initSystemAlerts();
        },

        initSystemAlerts: () => {
            $('.system-alert').each(function () {
                let $this = $(this);
                if ($this.data('sticky')) {
                    return;
                }
                let $removeAlert = $(removeButton);

                $removeAlert.on('click', () => {
                    $this.fadeOut('normal', () => $this.remove());
                });

                appendTo($this).append($removeAlert);

                if ($this.hasClass('system-alert-success')) {
                    fadeOutAfterCreation($this);
                }
            });

            function fadeOutAfterCreation(obj) {
                setTimeout(() => {
                    obj.fadeOut('slow', function () {
                        obj.remove();
                    });
                }, 5000);
            }
        }
    };

    return Alert;
}
